import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCheck, faMinus } from '@fortawesome/fontawesome-free-solid';
import { LeadsActions } from '../../actions';

import './lead.scss';
import { Submit } from '../Form';

class Lead extends Component {
    constructor(props) {
        super(props);

        this.state = {
            delete: false
        }
    }

    updateRequest(leadData) {
        const {dispatch, data} = this.props;
        const leadID = data._id;

        dispatch(LeadsActions.updateLead(leadID, leadData));
    }

    interestedRequest(interested) {
        return () => {
            this.setState({delete: !interested}, () => {
                this.updateRequest({interested: interested});
            });
        }
    }

    notInterested() {
        this.setState({delete: true});
    }

    contactRequest() {
        this.updateRequest({contact: true});
    }

    render() {
        const {name, phone, area, date, contact, interested, _id} = this.props.data;
        const {leads} = this.props;

        return (
            <div className={`lead ${(interested === undefined || interested === null) ? 'new': ''}`}>
                <div className="lcol leadName">
                    {name}
                </div>
                <div className="lcol leadDate">
                    {date && moment(date).format('DD/MM/YY')}
                    {!date &&  "ללא"}
                </div>
                <div className="lcol leadArea">
                    {area}
                    {!area && "ללא"}
                </div>
                <div className={`lcol leadPhone ${interested ? 'interested': ''}`}>
                    {interested && phone}
                    {!interested && 
                        <div className="interestedBtns">
                            <Submit className="first"
                                icon=""
                                text="מעוניין"
                                onClick={this.interestedRequest(true).bind(this)}
                                process={leads.updateLeadProcessList && leads.updateLeadProcessList[_id] && !this.state.delete}
                            />
                            <Submit className={`last ${this.state.delete ? 'hide': ''}`}
                                icon=""
                                text="לא מעוניין"
                                onClick={this.notInterested.bind(this)}
                                process={false}
                            />
                            <Submit className={`last warn ${!this.state.delete ? 'hide': ''}`}
                                icon=""
                                text="בטוח?"
                                onClick={this.interestedRequest(false).bind(this)}
                                process={leads.updateLeadProcessList && leads.updateLeadProcessList[_id] && this.state.delete}
                            />
                        </div>
                    }
                </div>
                <div className="lcol leadContact">
                    {contact && <span className="contactOk"><FontAwesomeIcon icon={faCheck}/></span>}
                    {!contact && interested && 
                        <Submit className="contactBtn"
                            icon=""
                            text="נוצר קשר"
                            onClick={this.contactRequest.bind(this)}
                            process={leads.updateLeadProcessList && leads.updateLeadProcessList[_id]}
                        />
                    }
                    {!contact && !interested && <FontAwesomeIcon icon={faMinus}/>}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        leads: state.leadsReducer
    }
}

const LeadWithRedux = connect(mapStateToProps)(Lead);
export {LeadWithRedux as Lead};


// WEBPACK FOOTER //
// ./src/components/LeadsPage/Lead.jsx